import {action, observable} from 'mobx';

class BasePaginationStore {
    /**
     * 总条数
     */
    @observable
    data_total = 0;

    /**
     * 当前页码
     */
    @observable
    page_cur = 1;

    /**
     * 每页条数
     */
    @observable
    page_size = 15;


    /**
     * 总页数
     */
    @observable
    page_total = 1;

    page_size_options = ['2', '5', '10', '15', '40', '50'];


    @action
    reset() {
        this.data_total = 0;
        this.page_cur = 1;
        this.page_size = 15;
        this.page_total = 1;
    }

    @action
    clear() {
        this.data_total = 0;
        this.page_cur = 1;
        this.page_total = 1;
    }

    @action
    setAttr(options) {
        for (let attr in options) {
            this[attr] = Number(options[attr])
        }
    }

    @action
    getAttr() {
        return {
            page_size: this.page_size,
            page_cur: this.page_cur
        }
    }

    @action
    setDataTotal(count) {
        this.data_total = count;
    }

    @action
    setPageCur(no) {
        this.page_cur = no;
    }

    @action
    setPageSize(size) {
        this.page_size = size
    }

    @action
    setPageTotal(count) {
        this.page_total = count
    }
}

export default BasePaginationStore;



// WEBPACK FOOTER //
// ./src/Store/Common/BasePaginationStore.js